<!-- TABLE -->
<table class="table cx-order-history-table">
  <thead class="cx-order-history-thead-mobile">
    <th scope="col" class="ordernumber">
      {{ 'customOrderHistory.orderNumber' | cxTranslate }}
    </th>
    <th scope="col" class="position">
      {{ 'customOrderHistory.position' | cxTranslate }}
    </th>
    <th scope="col" class="status">
      {{ 'customOrderHistory.status' | cxTranslate }}
    </th>
    <th scope="col" class="productcode">
      {{ 'customOrderHistory.productCode' | cxTranslate }}
    </th>
    <th scope="col" class="description">
      {{ 'customOrderHistory.description' | cxTranslate }}
    </th>
    <th scope="col" class="orderedquantity">
      {{ 'customOrderHistory.orderedQuantity' | cxTranslate }}
    </th>
    <th scope="col" class="deliveredquantity">
      {{ 'customOrderHistory.deliveredQuantity' | cxTranslate }}
    </th>
    <th scope="col" class="netprice">
      {{ 'customOrderHistory.netPrice' | cxTranslate }}
    </th>
  </thead>
  <tbody>
    @for (entry of entries; track entry) {
      <tr
        (click)="goToOrderDetail(entry)"
        >
        <!--SAP Order Number-->
        <td class="code">
          <div class="d-md-none cx-order-history-label">
            {{ 'customOrderHistory.orderNumber' | cxTranslate }}
          </div>
          <div class="cx-order-history-value">
            <a
            [routerLink]="
              {
                cxRoute: 'orderDetails',
                params: entry
              } | cxUrl
            "
              class="cx-order-history-value"
              >
              {{ entry?.code }}
            </a>
          </div>
        </td>
        <!-- entry position -->
        <td class="position">
          <div class="d-md-none cx-order-history-label">
            {{ 'customOrderHistory.position' | cxTranslate }}
          </div>
          <div class="cx-order-history-value">
            {{ entry?.position }}
          </div>
        </td>
        <!--Order Status-->
        <td class="status">
          <div class="d-md-none cx-order-history-label">
            {{ 'customOrderHistory.status' | cxTranslate }}
          </div>
          <div class="cx-order-history-value">
            <img
            src="assets/images/orderhistory/state_{{
              entry?.orderState | lowercase
            }}.gif"
              alt="{{ entry?.orderState }}"
            title="{{
              'customOrderHistory.states.' + entry?.orderState
                | cxTranslate
            }}"
              />
            </div>
          </td>
          <!-- entry product code -->
          <td class="product-code">
            <div class="d-md-none cx-order-history-label">
              {{ 'customOrderHistory.productCode' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ entry?.productCode }}
            </div>
          </td>
          <!-- entry description -->
          <td class="description">
            <div class="d-md-none cx-order-history-label">
              {{ 'customOrderHistory.description' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ entry?.description }}
            </div>
          </td>
          <!-- entry ordered quantity -->
          <td class="ordered-quantity">
            <div class="d-md-none cx-order-history-label">
              {{ 'customOrderHistory.orderedQuantity' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ entry?.orderedQuantity }}
            </div>
          </td>
          <!-- entry delivered quantity -->
          <td class="delivered-quantity">
            <div class="d-md-none cx-order-history-label">
              {{ 'customOrderHistory.deliveredQuantity' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ entry?.deliveredQuantity }}
            </div>
          </td>
          <!-- entry netPrice -->
          <td class="net-price">
            <div class="d-md-none cx-order-history-label">
              {{ 'customOrderHistory.netPrice' | cxTranslate }}
            </div>
            <div class="cx-order-history-value">
              {{ entry?.netPriceData.formattedValue }}
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
